(ns ycweb.app.website.help.common
  (:require
   [rum.core :as rum]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc help-center-banner < rum/reactive [app-atom {:keys [landing]}]
  [:div.u-bg-greenery
   {:class (u/bem :help-center-banner [(when landing :landing)])}
   [:div.yc-section
    (headings/heading "Help Centre" {:type :h1 :size :huge :center true})
    [:p.yc-paragraph.u-text-center
     "Ask a question, browse popular help topics or contact customer service."]
    [:div.u-block-center.u-max-width-640
     [:a.help-center-search
      (urlstate/href-on-click #(grid/dispatch-action app-atom :search/instant-search-popup {}))
      [:div.help-center-search__input-wrapper
       [:span.help-center-search__input
        "How can we help?"
        [:span.clip-text
         {:class (u/bem :unclip-text [:m])}
         " e.g. How to track my order"]]]
      [:div.help-center-search__button-wrapper
       [:span.help-center-search__button "Search"]]]]]])

(rum/defc breadcrumbs < rum/reactive [app-atom {:keys [id display-name url-name faqs?]}]
  [:nav.dlp-breadcrumbs
   [:ul.group
    {:class (u/bem :breadcrumbs [:centered])}
    [:li.breadcrumbs__item
     [:a
      (merge
        (if faqs?
          (urlstate/href-props app-atom "help")
          (urlstate/href-props app-atom "help" "faqs"))
        {:class (u/bem :breadcrumb__link [:back])})
      [:i {:class (u/bem :icon [:inline :default :is-dark :arrow-left])}]
      [:span.hidden-from-view "Back"]]]
    [:li.breadcrumbs__item
     (cond
       (= display-name "Cooking School")
       [:a.breadcrumb__link
        (urlstate/href-props app-atom "cooking-school") "Cooking School"]

       (= display-name "Wedding Registries")
       [:a.breadcrumb__link
        (urlstate/href-props app-atom "registry") "Registry"]

       (= display-name "Q&A Forum")
       [:a.breadcrumb__link
        (urlstate/href-props app-atom "forum") "Q&A Forum"]

       :else
       [:a.breadcrumb__link
        (urlstate/href-props app-atom "index") "Shop"])]
    [:li
     {:class (u/bem :breadcrumbs__item [:always-show])}
     [:a.breadcrumb__link
      (urlstate/href-props app-atom "help")
      [:span.unclip-text--s.clip-text--m
       [:i {:class (u/bem :icon [:inline :tiny :is-dark :arrow-left])}]
       "Back to "]
      "Help Centre"]]
    [:li.breadcrumbs__item
     [:a.breadcrumb__link (urlstate/href-props app-atom "help" "faqs") "FAQs"]]
    (when (and id display-name)
      [:li.breadcrumbs__item
       [:a.breadcrumb__link
        (urlstate/href-props app-atom "help" "category"
          {:id id :name url-name}) display-name]])]])

(rum/defc help-center-footer < rum/reactive [app-atom]
  [:div.u-block-center.u-max-width-640
   [:a.help-center-search.yc-field-highlight
    (urlstate/href-on-click #(grid/dispatch-action app-atom :search/instant-search-popup {}))
    [:div.help-center-search__input-wrapper
     [:span.help-center-search__input
      "How can we help?"
      [:span.clip-text
       {:class (u/bem :unclip-text [:m])}
       " e.g. How to track my order"]]]
    [:div.help-center-search__button-wrapper
     [:span.help-center-search__button "Search"]]]
   [:div.u-margin-top-20
    [:p.u-text-center
     {:class (u/bem :yc-paragraph [:flush])}
     "Still a bit stumped? "
     [:a.text-link
      (urlstate/href-on-click #(grid/dispatch-action app-atom :web.help/contact-popup {}))
      "Send us an email"]
     " or call 021 702 4969."]]]);;To change back to "0861 702 4969" when Telkom line is sorted